<script lang="ts">
	import type { Category } from "../../../core/schema/Category";
	import type { CategoryFiltration } from "../../../core/schema/CategoryFiltration";
	import type { CategorySeoPage } from "../../../core/schema/CategorySeoPage";
	import { priorityLabelNameMap } from "../../../core/schema/names/priorityLabelNameMap";
	import { getCategoryPath } from "../../../core/schema/paths/getCategoryPath";
	import { PriorityLabel } from "../../../core/schema/PriorityLabel";
	import ProductFiltrationLabel from "./Product/ProductFiltrationLabel.svelte";
	import { isEnum } from "../../../core/utils/enum/isEnum.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";

	export let filtration: CategoryFiltration[];
	export let category: Category;
	export let active: CategorySeoPage["type"] | undefined = undefined;

	const { TENANT_LOCALE } = getGlobalSettings();

	function changeFilter(filter: CategoryFiltration | undefined): void {
		active = filter?.value;
		const searchParams = new URLSearchParams(window.location.search);
		if (filter) {
			searchParams.set("filtr", filter.value);
		} else {
			searchParams.delete("filtr");
		}
		window.history.pushState({}, "", `${window.location.pathname}?${searchParams.toString()}`);
	}

	function getFilterUrl(filter: CategoryFiltration): string | undefined {
		const currentSeoPage = category.seoPages.find((seoPage) => seoPage.type === active);
		const newSeoPage = category.seoPages.find((seoPage) => seoPage.type === filter.value);
		if (currentSeoPage) {
			const searchParams = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");
			if (!newSeoPage) {
				searchParams.set("filtr", filter.value);
			}
			let url = `/${getCategoryPath(TENANT_LOCALE, category, newSeoPage)}`;
			if (searchParams.toString()) {
				url += `?${searchParams.toString()}`;
			}
			return url;
		} else if (newSeoPage) {
			return `/${getCategoryPath(TENANT_LOCALE, category, newSeoPage)}`;
		}
		return undefined;
	}

	const isPriorityLabel = isEnum(PriorityLabel);
	function getLabel(filter: CategoryFiltration): string {
		if (isPriorityLabel(filter.label[TENANT_LOCALE])) {
			return priorityLabelNameMap[filter.label[TENANT_LOCALE]][TENANT_LOCALE];
		}
		return filter.label[TENANT_LOCALE];
	}

	// eslint-disable-next-line no-warning-comments
	// FIXME remove this after upgrade to Svelte 5.
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
</script>

<div class="mx-auto my-4 flex w-fit max-w-[43rem] flex-col items-center gap-1 md:flex-row md:gap-4">
	<p class="text-base font-semibold leading-6">Filtr</p>
	<div class="flex flex-wrap items-center justify-center gap-1.5">
		<ProductFiltrationLabel
			clickable
			selected={active === undefined}
			on:click={() => {
				changeFilter(undefined);
			}}
		>
			Vše
		</ProductFiltrationLabel>
		{#each filtration as filter}
			{@const url = getFilterUrl(filter)}
			<ProductFiltrationLabel
				clickable
				selected={filter.value === active}
				href={url}
				on:click={() => {
					if (url) {
						return;
					}
					changeFilter(filter);
				}}
			>
				{getLabel(filter)}
			</ProductFiltrationLabel>
		{/each}
	</div>
</div>
